import { jsPDF } from "jspdf";

// Generate a branded acknowledgement receipt PDF for a submitted application.
export function generateReceipt(app) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const yellow = [255, 204, 0];
  const dark = [15, 17, 21];

  // Header band
  doc.setFillColor(...dark);
  doc.rect(0, 0, W, 90, "F");
  doc.setFillColor(...yellow);
  doc.rect(0, 90, W, 5, "F");

  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.text("RANCHI DIGITAL SEVA", 40, 45);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(255, 204, 0);
  doc.text("APPLICATION ACKNOWLEDGEMENT RECEIPT", 40, 65);

  // App ID box
  doc.setDrawColor(...yellow);
  doc.setLineWidth(1.5);
  doc.rect(40, 120, W - 80, 50);
  doc.setTextColor(120, 120, 120);
  doc.setFontSize(9);
  doc.text("APPLICATION ID", 55, 140);
  doc.setTextColor(...dark);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.text(app.app_id, 55, 162);

  // Details table
  const rows = [
    ["Service", app.service_type],
    ["Applicant Name", app.full_name],
    ["Date of Birth", app.date_of_birth],
    ["Gender", app.gender],
    ["Phone", app.phone],
    ["Email", app.email],
    ["Address", app.address],
    ["Documents Uploaded", (app.documents || []).map((d) => d.name).join(", ") || "None"],
    ["Status", (app.status || "submitted").replace(/_/g, " ").toUpperCase()],
    ["Submitted On", new Date(app.created_at || Date.now()).toLocaleString()],
  ];

  let y = 205;
  doc.setFontSize(10);
  rows.forEach(([k, v], i) => {
    if (i % 2 === 0) {
      doc.setFillColor(245, 245, 243);
      doc.rect(40, y - 14, W - 80, 26, "F");
    }
    doc.setFont("helvetica", "bold");
    doc.setTextColor(80, 80, 80);
    doc.text(String(k), 55, y);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(20, 20, 20);
    const lines = doc.splitTextToSize(String(v), W - 260);
    doc.text(lines, 230, y);
    y += 26 + (lines.length - 1) * 12;
  });

  // Footer
  y += 20;
  doc.setDrawColor(220, 220, 220);
  doc.line(40, y, W - 40, y);
  doc.setFontSize(8);
  doc.setTextColor(140, 140, 140);
  doc.text(
    "This is a computer-generated acknowledgement. Ranchi Digital Seva is a facilitation service and not a government body.",
    40, y + 18, { maxWidth: W - 80 }
  );
  doc.text("Track your application status anytime at your dashboard.", 40, y + 34);

  doc.save(`${app.app_id}-receipt.pdf`);
}
